// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items-container {\n  display: flex;\n}\n.items-container .data-table .action {\n  display: flex;\n  gap: 10px;\n}", ""]);
// Exports
module.exports = exports;
